import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 1024 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M562.88 68.032a192 192 0 0 1 120.064 42.24l146.88 117.76a192 192 0 0 1 71.872 149.76v458.24a128 128 0 0 1-128 128h-512a128 128 0 0 1-128-128v-640a128 128 0 0 1 128-128H562.88zm44.416 476.48h-307.2a45.504 45.504 0 0 0 0 91.008h307.2a45.504 45.504 0 0 0 0-91.008zM550.4 316.928H300.096a45.504 45.504 0 0 0 0 91.072H550.4a45.504 45.504 0 0 0 0-91.072z" /></svg>

const File = React.forwardRef((props, ref) => {
  return (
    <IconBase name="file" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

File.displayName = 'IconFile'

export default File
